var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("disclaimers-loader")
    : _c(
        "div",
        { staticClass: "row" },
        [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "row no-gutters" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header px-5" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row align-items-center justify-content-left",
                    },
                    [
                      _c(
                        "h6",
                        { staticClass: "grey-text text-darken-3 m-0" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "settings.disclaimers.defaultConsentRequest"
                                )
                              ) +
                              "\n              "
                          ),
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  title: _vm.$t(
                                    "settings.disclaimers.enabledMessage"
                                  ),
                                },
                                expression:
                                  "{\n                  title: $t('settings.disclaimers.enabledMessage')\n                }",
                              },
                            ],
                            staticClass: "ml-1 clickable text-primary",
                            attrs: { name: "info-circle" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5" }, [
                  _c(
                    "div",
                    { staticClass: "row align-items-end" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.$t(
                              "settings.disclaimers.defaultConsentDescription"
                            )
                          ) +
                          "\n            "
                      ),
                      _c("default-disclaimer-table", {
                        attrs: {
                          "default-disclaimer": _vm.GET_DEFAULT_DISCLAIMER,
                          "default-disclaimer-enabled":
                            _vm.IS_DEFAULT_DISCLAIMER_ENABLED,
                          "is-brokerage": _vm.isBrokerage,
                        },
                        on: {
                          "show-document-previewer": _vm.showDocumentPreviewer,
                          "update-default-disclaimer-enabled":
                            _vm.updateDefaultDisclaimerEnabled,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header px-5" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row align-items-center justify-content-between",
                    },
                    [
                      _c(
                        "h6",
                        { staticClass: "grey-text text-darken-3 m-0" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t("settings.disclaimers.consentRequests")
                              ) +
                              "\n              "
                          ),
                          _c("icon", {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip",
                                value: {
                                  title: _vm.$t(
                                    "settings.disclaimers.enabledMessage"
                                  ),
                                },
                                expression:
                                  "{\n                  title: $t('settings.disclaimers.enabledMessage')\n                }",
                              },
                            ],
                            staticClass: "ml-1 clickable text-primary",
                            attrs: { name: "info-circle" },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          on: {
                            click: function ($event) {
                              return _vm.openAddModal(true)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "settings.disclaimers.createConsentRequest"
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5" }, [
                  _c(
                    "div",
                    { staticClass: "row align-items-end" },
                    [
                      _c("consent-table", {
                        attrs: {
                          "consent-requests":
                            _vm.GET_DISCLAIMERS_FILTERED(true),
                        },
                        on: {
                          "delete-disclaimer": _vm.deleteDisclaimer,
                          "show-document-previewer": _vm.showDocumentPreviewer,
                          "update-disclaimer": _vm.updateDisclaimer,
                          "edit-disclaimer": _vm.openEditDisclaimer,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row no-gutters" }, [
              _c("div", { staticClass: "card" }, [
                _c("div", { staticClass: "card-header px-5" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row align-items-center justify-content-between",
                    },
                    [
                      _c("h6", { staticClass: "grey-text text-darken-3 m-0" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("settings.disclaimers.disclaimers")) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary btn-sm",
                          on: {
                            click: function ($event) {
                              return _vm.openAddModal(false)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.$t(
                                  "settings.disclaimers.createDisclaimerMessage"
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card-body px-5" }, [
                  _c(
                    "div",
                    { staticClass: "row align-items-end" },
                    [
                      _c("disclaimers-table", {
                        attrs: {
                          disclaimers: _vm.disclaimers,
                          "default-disclaimer-enabled":
                            _vm.IS_DEFAULT_DISCLAIMER_ENABLED,
                          "is-brokerage": _vm.isBrokerage,
                        },
                        on: {
                          "delete-disclaimer": _vm.deleteDisclaimer,
                          "show-document-previewer": _vm.showDocumentPreviewer,
                          "update-disclaimer": _vm.updateDisclaimer,
                          "edit-disclaimer": _vm.openEditDisclaimer,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("add-disclaimer-modal", {
            ref: "addDisclaimerModal",
            attrs: {
              "is-consent": _vm.consent,
              "client-username": _vm.userDetails.username,
              disclaimer: _vm.currentEditingDisclaimer,
            },
            on: {
              "create-disclaimer": _vm.createDisclaimer,
              hidden: function ($event) {
                _vm.currentEditingDisclaimer = null
              },
              "edit-disclaimer": _vm.handleEditDisclaimer,
            },
          }),
          _vm._v(" "),
          _c("document-preview-modal", {
            ref: "previewDocumentModal",
            attrs: {
              "file-name": _vm.currentFileName,
              "document-id": _vm.currentDocumentId,
              url: _vm.url,
            },
            on: { "download-document": _vm.handleDownloadDocument },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }